import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';

import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { addCohortEnrollment } from 'Workspace/Cohorts/store/actions';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { cohortId, accountId } = action;
  const workspaceCohortAccountEnroll = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_ACCOUNT_ENROLL,
    cohortId,
    accountId,
  });

  if (workspaceCohortAccountEnroll.type === constants.RTM_WORKSPACE_COHORT_ACCOUNT_ENROLL_OK) {
    const response = workspaceCohortAccountEnroll.response.enrollment;
    yield put(addCohortEnrollment(cohortId, response));
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedWorkspaceCohortAccountEnroll} />,
      })
    );
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_ACCOUNT_ENROLL, catchErrors, sendRequest, connection);
}
